<div class="p-5 redirect-to-ce">
  <div class="card">
    <div class="d-flex justify-content-center flex-column">
      <div class="netcore-logo">
        <img class="logo-img" src="/assets/images/context-charts/netcore-logo.svg" alt="Netcore Logo">
      </div>

      <ng-container *ngIf="shouldShowLoader">
        <div id="redirect-ce-loader">
          <app-px-loader [inlineLoader]="inlineLoader"></app-px-loader>
        </div>
        <div class="loader-text">
          Authenticating...
        </div>
      </ng-container>

      <ng-container *ngIf="!shouldShowLoader">
        <div class="netcore-baloon">
          <div class="lottie-player">
            <lottie-player src="../../../assets/lottieFiles/404.json" background="transparent" speed="1" loop autoplay>
            </lottie-player>
          </div>
        </div>
        <div class="error-msg">Something went wrong</div>
        <div class="contact-us-text mt-4">
          <div>Uh-oh! The link you’re trying to access seems invalid.</div>
          <div>Please contact us at <a href="mailto: helpdesk@netcorecloud.com"
              class="helpdesk-link">helpdesk@netcorecloud.com</a> if this problem persists.</div>
        </div>
      </ng-container>

    </div>
  </div>
</div>
